import { useTranslation } from 'react-i18next';

export function SocialProofBar() {
  const { t } = useTranslation();

  const companies = [
    t('landing.socialProof.company1'),
    t('landing.socialProof.company2'),
    t('landing.socialProof.company3'),
    t('landing.socialProof.company4'),
    t('landing.socialProof.company5'),
    t('landing.socialProof.company6'),
  ];

  const stats = [
    { value: t('landing.socialProof.stat1Value'), label: t('landing.socialProof.stat1Label') },
    { value: t('landing.socialProof.stat2Value'), label: t('landing.socialProof.stat2Label') },
    { value: t('landing.socialProof.stat3Value'), label: t('landing.socialProof.stat3Label') },
  ];

  return (
    <section className="py-16" style={{ backgroundColor: '#F4F5FF' }}>
      <div className="container">
        <p className="text-center text-sm font-medium text-[#1A1F3C]/50 uppercase tracking-wider mb-8">
          {t('landing.socialProof.heading')}
        </p>

        {/* Company logos / placeholders */}
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mb-12">
          {companies.map((name, i) => (
            <div
              key={i}
              className="px-5 py-2.5 rounded-lg border border-[#1A1F3C]/10 bg-white text-[#1A1F3C]/40 text-sm font-semibold"
            >
              {name}
            </div>
          ))}
        </div>

        {/* Stat bubbles */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 md:gap-12">
          {stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl font-bold text-[#4F6CFF]" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                {stat.value}
              </div>
              <div className="mt-1 text-sm text-[#1A1F3C]/60 max-w-[200px]">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
